// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Gif_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M13.5 6.75v10.5a.75.75 0 0 1-1.5 0V6.75a.75.75 0 0 1 1.5 0ZM21.75 6H16.5a.75.75 0 0 0-.75.75v10.5a.75.75 0 0 0 1.5 0v-4.5H21a.75.75 0 0 0 0-1.5h-3.75V7.5h4.5a.75.75 0 0 0 0-1.5ZM9 11.25H6.75a.75.75 0 0 0 0 1.5h1.5v1.5a2.25 2.25 0 0 1-4.5 0v-4.5A2.25 2.25 0 0 1 6 7.5c1.05 0 2.026.726 2.273 1.688a.75.75 0 0 0 1.454-.376C9.307 7.184 7.74 6 6 6a3.75 3.75 0 0 0-3.75 3.75v4.5a3.75 3.75 0 0 0 7.5 0V12a.75.75 0 0 0-.75-.75Z',
  viewBox: '0 0 24 24',
  glyph: 'Gif_Stroke2_Corner0_Rounded',
})

export const GifSquare_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M13.5 6.75v10.5a.75.75 0 0 1-1.5 0V6.75a.75.75 0 0 1 1.5 0ZM21.75 6H16.5a.75.75 0 0 0-.75.75v10.5a.75.75 0 0 0 1.5 0v-4.5H21a.75.75 0 0 0 0-1.5h-3.75V7.5h4.5a.75.75 0 0 0 0-1.5ZM9 11.25H6.75a.75.75 0 0 0 0 1.5h1.5v1.5a2.25 2.25 0 0 1-4.5 0v-4.5A2.25 2.25 0 0 1 6 7.5c1.05 0 2.026.726 2.273 1.688a.75.75 0 0 0 1.454-.376C9.307 7.184 7.74 6 6 6a3.75 3.75 0 0 0-3.75 3.75v4.5a3.75 3.75 0 0 0 7.5 0V12a.75.75 0 0 0-.75-.75Z',
  viewBox: '0 0 24 24',
  glyph: 'GifSquare_Stroke2_Corner2_Rounded',
})
